<template>
  <!--幸运星明细页面-->
  <tk-container
    disable-scroll
  >
    <!--列表头部-->
    <grey-header slot="header" :title="'幸运星明细'" :icon="'return'"></grey-header>
    <!--记录列表-->
    <tk-container
      infiniteScroll
      ref="resetLuckyStarRecords"
      class="b-g-f"
      @loadingMore="getLuckyStarRecords"
    >
      <div
        v-for="(s, index) in luckyStarRecords"
        :key="index"
      >
        <tk-flex
          middle
          between
          class="p-12"
        >
          <div class="full-width tk-grid-9">
            <div class="font-14 van-ellipsis">{{s.access}}</div>
            <div class="caption m-t-10">{{s.createdAt | datetime}}</div>
          </div>
          <tk-flex middle class="tk-grid-3" right wrap gutter="5">
            <div class="primary font-bold">
              {{s.revenue === 'income' ? '+' + s.number : '-' + s.number}}
            </div>
            <div class="p-b-2">
              <tk-avatar size="22" color="rgba(247, 200, 75, 1)">
                <div class="star-image">
                  <tk-image :src="'https://s3.moke.cloud/dianpei/108813c9-9a0e-41aa-8148-279cf2930387.png'" width="14" height="14"></tk-image>
                </div>
              </tk-avatar>
            </div>
          </tk-flex>
        </tk-flex>
      </div>
    </tk-container>
  </tk-container>
</template>

<script>
export default {
  data () {
    return {
      status: false, // 页面状态
      luckyStarRecords: [] // 幸运星记录数据
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  mounted () {
    this.setStatusBar('dark')
  },
  methods: {
    /**
    * 获取幸运星明细数据
    * @date: 2020/4/16
    */
    async getLuckyStarRecords (page, next) {
      let luckyStarRecords = await this.$tkParse.getList(`/classes/luckyStarRecords`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-createdAt',
          where: {
            user: this.userInfo.objectId
          }
        }
      })
      this.luckyStarRecords = [...this.luckyStarRecords, ...luckyStarRecords]
      if (luckyStarRecords.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.star-image {
  width: 14px;
  height: 14px;
}
</style>
